import { ROTATION_STATUSES } from '@/config/constants';

export type CheckRotationStatusWarningOptions = {
	lastPlayedAt: string[];
	rotationStatus?: string | null;
	comparisonISODate: string;
};

export const checkRotationStatusWarning = ({
	rotationStatus,
	lastPlayedAt,
	comparisonISODate,
}: CheckRotationStatusWarningOptions): string | boolean => {
	const rotationStatusDefinition = ROTATION_STATUSES.find(
		(r) => r.key === rotationStatus,
	);
	if (!rotationStatusDefinition?.warningValidateFn) {
		return false;
	}
	const isValid = rotationStatusDefinition.warningValidateFn(
		lastPlayedAt,
		comparisonISODate,
	);

	return !isValid
		? rotationStatusDefinition.warningDescription || 'warning'
		: false;
};
